import { styled } from '@/stitches.config';
import { useVideoStore } from '../hooks/useVideoStore';

export function Duration({ percent }: { percent: number }) {
  const { duration } = useVideoStore((state) => ({
    duration: state.duration,
  }));

  const seconds = duration * percent;
  const time = formatTime(seconds);

  return (
    <Time
      dateTime={`PT${Math.floor(seconds / 60)}M${Math.round(seconds % 60)}S`}
    >
      {time}
    </Time>
  );
}

const Time = styled('time', {
  fontSize: '$1',
  margin: '0 $2',
  fontVariantNumeric: 'tabular-nums',
});

function formatTime(seconds: number) {
  // Calculate hours, minutes, and seconds
  const totalSeconds = Math.round(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  let remainingSeconds = totalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  remainingSeconds = remainingSeconds % 60;

  // Add leading zeros if needed
  const formattedHours = hours < 10 ? '0' + hours : hours;
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  const formattedSeconds =
    remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

  let formattedTime = `${formattedMinutes}:${formattedSeconds}`;

  // Add hours if greater than 0
  if (hours > 0) {
    formattedTime = `${formattedHours}:${formattedTime}`;
  }

  return formattedTime;
}
